import {
	Grid,
	Tabs,
	TabsButton,
	TabsButtonGroup,
	TabsContent,
	Text,
} from '@mlc/web-ui-toolkit';
import numeral from 'numeral';
import React, { useState } from 'react';
import { useAdviserDetails, useSearchResults } from '../../hooks/AppStateHook';
import AllResultsTabContent from './AllResultsTabContent/AllResultsTabContent';

export interface Props {
	totalCount: number;
	searchFilters: any;
	customerNumber: string;
	customerToken: string;
	loading: boolean;
}

type State = {
	totalCount: number;
	error: boolean;
};

const SearchResults = () => {
	const [totalCount, setTotalCount] = useState(0);

	const { customerToken, customerNumber } = useAdviserDetails();
	const { searchFilters } = useSearchResults();

	if (!customerNumber || !customerToken) {
		return null;
	}
	return (
		<Grid>
			<Tabs ariaLabel="Search Results">
				<TabsButtonGroup>
					<TabsButton>
						<Text>{`All (${numeral(totalCount).format('0,0')})`}</Text>
					</TabsButton>
				</TabsButtonGroup>
				<TabsContent>
					<AllResultsTabContent
						customerNumber={customerNumber}
						customerToken={customerToken}
						totalCount={totalCount}
						searchFilters={searchFilters}
						updateTotalResultsCount={(totalCount: number) => {
							setTotalCount(totalCount);
						}}
					/>
				</TabsContent>
			</Tabs>
		</Grid>
	);
};

export default SearchResults;
